import React from 'react';

export default function Toast(props) {
    return (
        <div id={props.id} className="toast" style={{ position: 'absolute', top: 0, right: 0 }} data-delay={2000}>
            <div className="toast-header">
                <strong className="mr-auto">Info</strong>
                <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="toast-body">{props.message}</div>
        </div>
    );
}
